import { Component, OnInit } from '@angular/core';
import { ContextService } from '@apply4u/services/context-service';

@Component({
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css'],
  standalone:true
})
export class LogoutComponent implements OnInit {

  constructor(private contextService: ContextService) {
  }

  ngOnInit(): void {
    if (this.contextService.IsBrowser) {
      this.contextService.SignOutRedirectCallback().catch(e => {
        if (this.contextService.IsBrowser) {
          console.log(`SignOut error: ${e}`);
        }
      });
    }
  }
}
